import { service } from '@maia/cart';
import { queryOptions } from '@tanstack/react-query';

export function getCompositionsOptions(
  params: Parameters<typeof service.getCompositions>[number],
) {
  return queryOptions({
    queryFn: () => service.getCompositions(params),
    queryKey: [
      'getCompositions',
      params.cartGuid,
      params.productGuid,
      params.customerGuid,
    ],
    gcTime: 0,
  });
}
